import { formValueSelector, arrayRemove, arrayPush } from 'redux-form';
import { REDUX_FORM_CHANGE } from '@hbrisk/sp3-risk-model-support/actions/types.js';
import {
  BUILDING_TYPE_DIR_1,
  BUILDING_TYPE_DIR_2,
  STRUCTURAL_RESPONSES,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import reconcileStructuralResponses from '@hbrisk/sp3-risk-model-support/models/structuralResponses/reconcileStructuralResponses/index.js';

import { selectResponseItemKeysWithDefinedComponents } from '#selectors/ui/form/model.js';

const updateStructuralResponsesOnBuildingTypeChange = ({ store, action, form }) => {
  const { type } = action;
  if (type === REDUX_FORM_CHANGE) {
    const {
      meta: { field, form: actionForm },
    } = action;
    if (actionForm === form && [BUILDING_TYPE_DIR_1, BUILDING_TYPE_DIR_2].includes(field)) {
      const state = store.getState();
      const {
        [BUILDING_TYPE_DIR_1]: buildingTypeDir1,
        [BUILDING_TYPE_DIR_2]: buildingTypeDir2,
        [STRUCTURAL_RESPONSES]: structuralResponses,
      } = formValueSelector(form)(
        state,
        BUILDING_TYPE_DIR_1,
        BUILDING_TYPE_DIR_2,
        STRUCTURAL_RESPONSES
      );

      const definedComponentEdpKeys =
        selectResponseItemKeysWithDefinedComponents(actionForm)(state);

      // Single source of truth for the building-type -> structuralResponses rule, shared with the
      // extraction worker (support/models/structuralResponses/reconcileStructuralResponses, #137).
      // The delta's remove indexes are descending, so applying them in order needs no re-indexing.
      const { toRemove, toAdd } = reconcileStructuralResponses({
        structuralResponses,
        buildingTypeDir1,
        buildingTypeDir2,
        definedComponentEdpKeys,
      });

      toRemove.forEach(index => {
        store.dispatch(arrayRemove(form, STRUCTURAL_RESPONSES, index));
      });

      toAdd.forEach(itemAsValues => {
        store.dispatch(arrayPush(form, STRUCTURAL_RESPONSES, itemAsValues));
      });
    }
  }
};

export default updateStructuralResponsesOnBuildingTypeChange;
